import LoadingSkeleton from "components/pages/TemplatesGalleryPage/LoadingSkeleton";
import dynamic from "next/dynamic";
import { forwardRef } from "react";

interface DynamicHighchartsChartProps {
  options: Highcharts.Options;
  constructorType?: string;
  className?: string;
  immutable?: boolean;
  allowChartUpdate?: boolean;
  forwardedRef?: React.Ref<RefObjectForHighchartsReact | null>;
}

export type RefObjectForHighchartsReact = {
  chart: Highcharts.Chart;
  container: React.RefObject<HTMLDivElement>;
};

const HighchartsChart = dynamic(() => import("./HighchartsChart"), {
  ssr: false,
  loading: () => <LoadingSkeleton className="h-96" count={1} />,
});

export default forwardRef<RefObjectForHighchartsReact | null, DynamicHighchartsChartProps>((props, ref) => {
  return <HighchartsChart forwardedRef={ref} {...props} />;
});
